import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const Container = styled.div<{ type: 'warn' | 'info' }>`
  padding: ${tokens.spacer.x2};
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
  background-color: ${({ type }) =>
    type === 'warn' ? tokens.color.bg_warning : tokens.color.neutral_100};
`;

interface GenericFilterFooterMessageProps {
  children?: ReactNode;
  type?: 'warn' | 'info';
}

export function GenericFilterFooterMessage({
  children,
  type = 'warn',
}: GenericFilterFooterMessageProps): JSX.Element {
  return <Container type={type}>{children}</Container>;
}
